import { Brand } from "@/internal/modules/providers/interfaces/Brand";
import axios from "@/lib/axios";
import { useQuery } from "@tanstack/vue-query";

interface Props {
  immediate?: boolean;
  params?: Params;
}

interface Params {
  id: number | string;
}

const getBrand = async (param: Params): Promise<Brand> => {
  const { data } = await axios.get<Brand>(`/api/internal/brands/${param.id}`);

  return data;
};

const useBrand = (props: Props) => {
  const { immediate = true, params } = props;

  const { data, isLoading, refetch } = useQuery(
    ["brand", params],
    () => getBrand(params!),
    {
      enabled: immediate,
    },
  );

  return {
    data,
    isLoading,
    refetch,
  };
};

export default useBrand;
